import { atom } from 'jotai';
export const searchAtom = atom('');
